/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PersonvernRouteImport } from './routes/personvern'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedOrgSlugRouteImport } from './routes/_authenticated/$orgSlug'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as ReviewDraftIdRouteImport } from './routes/review.$draftId'
import { Route as AuthenticatedOrgSlugIndexRouteImport } from './routes/_authenticated/$orgSlug.index'
import { Route as AuthenticatedOrgSlugAuditRouteImport } from './routes/_authenticated/$orgSlug.audit'
import { Route as AuthenticatedOrgSlugMediaPerformanceRouteImport } from './routes/_authenticated/$orgSlug.media-performance'
import { Route as AuthenticatedOrgSlugSettingsRouteImport } from './routes/_authenticated/$orgSlug.settings'
import { Route as AuthenticatedOrgSlugAuditIndexRouteImport } from './routes/_authenticated/$orgSlug.audit.index'
import { Route as AuthenticatedOrgSlugAuditActionsRouteImport } from './routes/_authenticated/$orgSlug.audit.actions'
import { Route as AuthenticatedOrgSlugAuditNotesRouteImport } from './routes/_authenticated/$orgSlug.audit.notes'
import { Route as AuthenticatedOrgSlugAuditProposalsRouteImport } from './routes/_authenticated/$orgSlug.audit.proposals'
import { Route as AuthenticatedOrgSlugLaunchBudgetsRouteImport } from './routes/_authenticated/$orgSlug.launch.budgets'
import { Route as AuthenticatedOrgSlugLaunchCreateRouteImport } from './routes/_authenticated/$orgSlug.launch.create'
import { Route as AuthenticatedOrgSlugLaunchEditRouteImport } from './routes/_authenticated/$orgSlug.launch.edit'
import { Route as AuthenticatedOrgSlugMediaPerformanceIndexRouteImport } from './routes/_authenticated/$orgSlug.media-performance.index'
import { Route as AuthenticatedOrgSlugMediaPerformanceSectionRouteImport } from './routes/_authenticated/$orgSlug.media-performance.$section'
import { Route as AuthenticatedOrgSlugReviewIndexRouteImport } from './routes/_authenticated/$orgSlug.review.index'
import { Route as AuthenticatedOrgSlugReviewDraftIdRouteImport } from './routes/_authenticated/$orgSlug.review.$draftId'
import { Route as AuthenticatedOrgSlugAuditNotesNoteIdRouteImport } from './routes/_authenticated/$orgSlug.audit_.notes.$noteId'
import { Route as AuthenticatedOrgSlugAuditReportsReportIdRouteImport } from './routes/_authenticated/$orgSlug.audit_.reports.$reportId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonvernRoute = PersonvernRouteImport.update({
  id: '/personvern',
  path: '/personvern',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrgSlugRoute = AuthenticatedOrgSlugRouteImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewDraftIdRoute = ReviewDraftIdRouteImport.update({
  id: '/review/$draftId',
  path: '/review/$draftId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrgSlugIndexRoute =
  AuthenticatedOrgSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAuditRoute =
  AuthenticatedOrgSlugAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugMediaPerformanceRoute =
  AuthenticatedOrgSlugMediaPerformanceRouteImport.update({
    id: '/media-performance',
    path: '/media-performance',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugSettingsRoute =
  AuthenticatedOrgSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAuditIndexRoute =
  AuthenticatedOrgSlugAuditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugAuditRoute,
  } as any)
const AuthenticatedOrgSlugAuditActionsRoute =
  AuthenticatedOrgSlugAuditActionsRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => AuthenticatedOrgSlugAuditRoute,
  } as any)
const AuthenticatedOrgSlugAuditNotesRoute =
  AuthenticatedOrgSlugAuditNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedOrgSlugAuditRoute,
  } as any)
const AuthenticatedOrgSlugAuditProposalsRoute =
  AuthenticatedOrgSlugAuditProposalsRouteImport.update({
    id: '/proposals',
    path: '/proposals',
    getParentRoute: () => AuthenticatedOrgSlugAuditRoute,
  } as any)
const AuthenticatedOrgSlugLaunchBudgetsRoute =
  AuthenticatedOrgSlugLaunchBudgetsRouteImport.update({
    id: '/launch/budgets',
    path: '/launch/budgets',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugLaunchCreateRoute =
  AuthenticatedOrgSlugLaunchCreateRouteImport.update({
    id: '/launch/create',
    path: '/launch/create',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugLaunchEditRoute =
  AuthenticatedOrgSlugLaunchEditRouteImport.update({
    id: '/launch/edit',
    path: '/launch/edit',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugMediaPerformanceIndexRoute =
  AuthenticatedOrgSlugMediaPerformanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgSlugMediaPerformanceRoute,
  } as any)
const AuthenticatedOrgSlugMediaPerformanceSectionRoute =
  AuthenticatedOrgSlugMediaPerformanceSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedOrgSlugMediaPerformanceRoute,
  } as any)
const AuthenticatedOrgSlugReviewIndexRoute =
  AuthenticatedOrgSlugReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugReviewDraftIdRoute =
  AuthenticatedOrgSlugReviewDraftIdRouteImport.update({
    id: '/review/$draftId',
    path: '/review/$draftId',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAuditNotesNoteIdRoute =
  AuthenticatedOrgSlugAuditNotesNoteIdRouteImport.update({
    id: '/audit_/notes/$noteId',
    path: '/audit/notes/$noteId',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugAuditReportsReportIdRoute =
  AuthenticatedOrgSlugAuditReportsReportIdRouteImport.update({
    id: '/audit_/reports/$reportId',
    path: '/audit/reports/$reportId',
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/personvern': typeof PersonvernRoute
  '/privacy': typeof PrivacyRoute
  '/$orgSlug': typeof AuthenticatedOrgSlugRouteWithChildren
  '/admin': typeof AuthenticatedAdminRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/review/$draftId': typeof ReviewDraftIdRoute
  '/$orgSlug/audit': typeof AuthenticatedOrgSlugAuditRouteWithChildren
  '/$orgSlug/media-performance': typeof AuthenticatedOrgSlugMediaPerformanceRouteWithChildren
  '/$orgSlug/settings': typeof AuthenticatedOrgSlugSettingsRoute
  '/$orgSlug/': typeof AuthenticatedOrgSlugIndexRoute
  '/$orgSlug/audit/actions': typeof AuthenticatedOrgSlugAuditActionsRoute
  '/$orgSlug/audit/notes': typeof AuthenticatedOrgSlugAuditNotesRoute
  '/$orgSlug/audit/proposals': typeof AuthenticatedOrgSlugAuditProposalsRoute
  '/$orgSlug/launch/budgets': typeof AuthenticatedOrgSlugLaunchBudgetsRoute
  '/$orgSlug/launch/create': typeof AuthenticatedOrgSlugLaunchCreateRoute
  '/$orgSlug/launch/edit': typeof AuthenticatedOrgSlugLaunchEditRoute
  '/$orgSlug/media-performance/$section': typeof AuthenticatedOrgSlugMediaPerformanceSectionRoute
  '/$orgSlug/review/$draftId': typeof AuthenticatedOrgSlugReviewDraftIdRoute
  '/$orgSlug/audit/': typeof AuthenticatedOrgSlugAuditIndexRoute
  '/$orgSlug/media-performance/': typeof AuthenticatedOrgSlugMediaPerformanceIndexRoute
  '/$orgSlug/review/': typeof AuthenticatedOrgSlugReviewIndexRoute
  '/$orgSlug/audit/notes/$noteId': typeof AuthenticatedOrgSlugAuditNotesNoteIdRoute
  '/$orgSlug/audit/reports/$reportId': typeof AuthenticatedOrgSlugAuditReportsReportIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/personvern': typeof PersonvernRoute
  '/privacy': typeof PrivacyRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/review/$draftId': typeof ReviewDraftIdRoute
  '/': typeof AuthenticatedIndexRoute
  '/$orgSlug/settings': typeof AuthenticatedOrgSlugSettingsRoute
  '/$orgSlug': typeof AuthenticatedOrgSlugIndexRoute
  '/$orgSlug/audit/actions': typeof AuthenticatedOrgSlugAuditActionsRoute
  '/$orgSlug/audit/notes': typeof AuthenticatedOrgSlugAuditNotesRoute
  '/$orgSlug/audit/proposals': typeof AuthenticatedOrgSlugAuditProposalsRoute
  '/$orgSlug/launch/budgets': typeof AuthenticatedOrgSlugLaunchBudgetsRoute
  '/$orgSlug/launch/create': typeof AuthenticatedOrgSlugLaunchCreateRoute
  '/$orgSlug/launch/edit': typeof AuthenticatedOrgSlugLaunchEditRoute
  '/$orgSlug/media-performance/$section': typeof AuthenticatedOrgSlugMediaPerformanceSectionRoute
  '/$orgSlug/review/$draftId': typeof AuthenticatedOrgSlugReviewDraftIdRoute
  '/$orgSlug/audit': typeof AuthenticatedOrgSlugAuditIndexRoute
  '/$orgSlug/media-performance': typeof AuthenticatedOrgSlugMediaPerformanceIndexRoute
  '/$orgSlug/review': typeof AuthenticatedOrgSlugReviewIndexRoute
  '/$orgSlug/audit/notes/$noteId': typeof AuthenticatedOrgSlugAuditNotesNoteIdRoute
  '/$orgSlug/audit/reports/$reportId': typeof AuthenticatedOrgSlugAuditReportsReportIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/personvern': typeof PersonvernRoute
  '/privacy': typeof PrivacyRoute
  '/_authenticated/$orgSlug': typeof AuthenticatedOrgSlugRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/review/$draftId': typeof ReviewDraftIdRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$orgSlug/audit': typeof AuthenticatedOrgSlugAuditRouteWithChildren
  '/_authenticated/$orgSlug/media-performance': typeof AuthenticatedOrgSlugMediaPerformanceRouteWithChildren
  '/_authenticated/$orgSlug/settings': typeof AuthenticatedOrgSlugSettingsRoute
  '/_authenticated/$orgSlug/': typeof AuthenticatedOrgSlugIndexRoute
  '/_authenticated/$orgSlug/audit/actions': typeof AuthenticatedOrgSlugAuditActionsRoute
  '/_authenticated/$orgSlug/audit/notes': typeof AuthenticatedOrgSlugAuditNotesRoute
  '/_authenticated/$orgSlug/audit/proposals': typeof AuthenticatedOrgSlugAuditProposalsRoute
  '/_authenticated/$orgSlug/launch/budgets': typeof AuthenticatedOrgSlugLaunchBudgetsRoute
  '/_authenticated/$orgSlug/launch/create': typeof AuthenticatedOrgSlugLaunchCreateRoute
  '/_authenticated/$orgSlug/launch/edit': typeof AuthenticatedOrgSlugLaunchEditRoute
  '/_authenticated/$orgSlug/media-performance/$section': typeof AuthenticatedOrgSlugMediaPerformanceSectionRoute
  '/_authenticated/$orgSlug/review/$draftId': typeof AuthenticatedOrgSlugReviewDraftIdRoute
  '/_authenticated/$orgSlug/audit/': typeof AuthenticatedOrgSlugAuditIndexRoute
  '/_authenticated/$orgSlug/media-performance/': typeof AuthenticatedOrgSlugMediaPerformanceIndexRoute
  '/_authenticated/$orgSlug/review/': typeof AuthenticatedOrgSlugReviewIndexRoute
  '/_authenticated/$orgSlug/audit_/notes/$noteId': typeof AuthenticatedOrgSlugAuditNotesNoteIdRoute
  '/_authenticated/$orgSlug/audit_/reports/$reportId': typeof AuthenticatedOrgSlugAuditReportsReportIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/personvern'
    | '/privacy'
    | '/$orgSlug'
    | '/admin'
    | '/oauth/consent'
    | '/review/$draftId'
    | '/$orgSlug/audit'
    | '/$orgSlug/media-performance'
    | '/$orgSlug/settings'
    | '/$orgSlug/'
    | '/$orgSlug/audit/actions'
    | '/$orgSlug/audit/notes'
    | '/$orgSlug/audit/proposals'
    | '/$orgSlug/launch/budgets'
    | '/$orgSlug/launch/create'
    | '/$orgSlug/launch/edit'
    | '/$orgSlug/media-performance/$section'
    | '/$orgSlug/review/$draftId'
    | '/$orgSlug/audit/'
    | '/$orgSlug/media-performance/'
    | '/$orgSlug/review/'
    | '/$orgSlug/audit/notes/$noteId'
    | '/$orgSlug/audit/reports/$reportId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/personvern'
    | '/privacy'
    | '/admin'
    | '/oauth/consent'
    | '/review/$draftId'
    | '/'
    | '/$orgSlug/settings'
    | '/$orgSlug'
    | '/$orgSlug/audit/actions'
    | '/$orgSlug/audit/notes'
    | '/$orgSlug/audit/proposals'
    | '/$orgSlug/launch/budgets'
    | '/$orgSlug/launch/create'
    | '/$orgSlug/launch/edit'
    | '/$orgSlug/media-performance/$section'
    | '/$orgSlug/review/$draftId'
    | '/$orgSlug/audit'
    | '/$orgSlug/media-performance'
    | '/$orgSlug/review'
    | '/$orgSlug/audit/notes/$noteId'
    | '/$orgSlug/audit/reports/$reportId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/personvern'
    | '/privacy'
    | '/_authenticated/$orgSlug'
    | '/_authenticated/admin'
    | '/oauth/consent'
    | '/review/$draftId'
    | '/_authenticated/'
    | '/_authenticated/$orgSlug/audit'
    | '/_authenticated/$orgSlug/media-performance'
    | '/_authenticated/$orgSlug/settings'
    | '/_authenticated/$orgSlug/'
    | '/_authenticated/$orgSlug/audit/actions'
    | '/_authenticated/$orgSlug/audit/notes'
    | '/_authenticated/$orgSlug/audit/proposals'
    | '/_authenticated/$orgSlug/launch/budgets'
    | '/_authenticated/$orgSlug/launch/create'
    | '/_authenticated/$orgSlug/launch/edit'
    | '/_authenticated/$orgSlug/media-performance/$section'
    | '/_authenticated/$orgSlug/review/$draftId'
    | '/_authenticated/$orgSlug/audit/'
    | '/_authenticated/$orgSlug/media-performance/'
    | '/_authenticated/$orgSlug/review/'
    | '/_authenticated/$orgSlug/audit_/notes/$noteId'
    | '/_authenticated/$orgSlug/audit_/reports/$reportId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PersonvernRoute: typeof PersonvernRoute
  PrivacyRoute: typeof PrivacyRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ReviewDraftIdRoute: typeof ReviewDraftIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personvern': {
      id: '/personvern'
      path: '/personvern'
      fullPath: '/personvern'
      preLoaderRoute: typeof PersonvernRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$orgSlug': {
      id: '/_authenticated/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/$orgSlug'
      preLoaderRoute: typeof AuthenticatedOrgSlugRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$draftId': {
      id: '/review/$draftId'
      path: '/review/$draftId'
      fullPath: '/review/$draftId'
      preLoaderRoute: typeof ReviewDraftIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$orgSlug/': {
      id: '/_authenticated/$orgSlug/'
      path: '/'
      fullPath: '/$orgSlug/'
      preLoaderRoute: typeof AuthenticatedOrgSlugIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/audit': {
      id: '/_authenticated/$orgSlug/audit'
      path: '/audit'
      fullPath: '/$orgSlug/audit'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/media-performance': {
      id: '/_authenticated/$orgSlug/media-performance'
      path: '/media-performance'
      fullPath: '/$orgSlug/media-performance'
      preLoaderRoute: typeof AuthenticatedOrgSlugMediaPerformanceRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/settings': {
      id: '/_authenticated/$orgSlug/settings'
      path: '/settings'
      fullPath: '/$orgSlug/settings'
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/audit/': {
      id: '/_authenticated/$orgSlug/audit/'
      path: '/'
      fullPath: '/$orgSlug/audit/'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAuditRoute
    }
    '/_authenticated/$orgSlug/audit/actions': {
      id: '/_authenticated/$orgSlug/audit/actions'
      path: '/actions'
      fullPath: '/$orgSlug/audit/actions'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditActionsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAuditRoute
    }
    '/_authenticated/$orgSlug/audit/notes': {
      id: '/_authenticated/$orgSlug/audit/notes'
      path: '/notes'
      fullPath: '/$orgSlug/audit/notes'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditNotesRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAuditRoute
    }
    '/_authenticated/$orgSlug/audit/proposals': {
      id: '/_authenticated/$orgSlug/audit/proposals'
      path: '/proposals'
      fullPath: '/$orgSlug/audit/proposals'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditProposalsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugAuditRoute
    }
    '/_authenticated/$orgSlug/launch/budgets': {
      id: '/_authenticated/$orgSlug/launch/budgets'
      path: '/launch/budgets'
      fullPath: '/$orgSlug/launch/budgets'
      preLoaderRoute: typeof AuthenticatedOrgSlugLaunchBudgetsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/launch/create': {
      id: '/_authenticated/$orgSlug/launch/create'
      path: '/launch/create'
      fullPath: '/$orgSlug/launch/create'
      preLoaderRoute: typeof AuthenticatedOrgSlugLaunchCreateRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/launch/edit': {
      id: '/_authenticated/$orgSlug/launch/edit'
      path: '/launch/edit'
      fullPath: '/$orgSlug/launch/edit'
      preLoaderRoute: typeof AuthenticatedOrgSlugLaunchEditRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/media-performance/': {
      id: '/_authenticated/$orgSlug/media-performance/'
      path: '/'
      fullPath: '/$orgSlug/media-performance/'
      preLoaderRoute: typeof AuthenticatedOrgSlugMediaPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugMediaPerformanceRoute
    }
    '/_authenticated/$orgSlug/media-performance/$section': {
      id: '/_authenticated/$orgSlug/media-performance/$section'
      path: '/$section'
      fullPath: '/$orgSlug/media-performance/$section'
      preLoaderRoute: typeof AuthenticatedOrgSlugMediaPerformanceSectionRouteImport
      parentRoute: typeof AuthenticatedOrgSlugMediaPerformanceRoute
    }
    '/_authenticated/$orgSlug/review/': {
      id: '/_authenticated/$orgSlug/review/'
      path: '/review'
      fullPath: '/$orgSlug/review/'
      preLoaderRoute: typeof AuthenticatedOrgSlugReviewIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/review/$draftId': {
      id: '/_authenticated/$orgSlug/review/$draftId'
      path: '/review/$draftId'
      fullPath: '/$orgSlug/review/$draftId'
      preLoaderRoute: typeof AuthenticatedOrgSlugReviewDraftIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/audit_/notes/$noteId': {
      id: '/_authenticated/$orgSlug/audit_/notes/$noteId'
      path: '/audit/notes/$noteId'
      fullPath: '/$orgSlug/audit/notes/$noteId'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditNotesNoteIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    '/_authenticated/$orgSlug/audit_/reports/$reportId': {
      id: '/_authenticated/$orgSlug/audit_/reports/$reportId'
      path: '/audit/reports/$reportId'
      fullPath: '/$orgSlug/audit/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedOrgSlugAuditReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
  }
}

interface AuthenticatedOrgSlugAuditRouteChildren {
  AuthenticatedOrgSlugAuditActionsRoute: typeof AuthenticatedOrgSlugAuditActionsRoute
  AuthenticatedOrgSlugAuditNotesRoute: typeof AuthenticatedOrgSlugAuditNotesRoute
  AuthenticatedOrgSlugAuditProposalsRoute: typeof AuthenticatedOrgSlugAuditProposalsRoute
  AuthenticatedOrgSlugAuditIndexRoute: typeof AuthenticatedOrgSlugAuditIndexRoute
}

const AuthenticatedOrgSlugAuditRouteChildren: AuthenticatedOrgSlugAuditRouteChildren =
  {
    AuthenticatedOrgSlugAuditActionsRoute:
      AuthenticatedOrgSlugAuditActionsRoute,
    AuthenticatedOrgSlugAuditNotesRoute: AuthenticatedOrgSlugAuditNotesRoute,
    AuthenticatedOrgSlugAuditProposalsRoute:
      AuthenticatedOrgSlugAuditProposalsRoute,
    AuthenticatedOrgSlugAuditIndexRoute: AuthenticatedOrgSlugAuditIndexRoute,
  }

const AuthenticatedOrgSlugAuditRouteWithChildren =
  AuthenticatedOrgSlugAuditRoute._addFileChildren(
    AuthenticatedOrgSlugAuditRouteChildren,
  )

interface AuthenticatedOrgSlugMediaPerformanceRouteChildren {
  AuthenticatedOrgSlugMediaPerformanceSectionRoute: typeof AuthenticatedOrgSlugMediaPerformanceSectionRoute
  AuthenticatedOrgSlugMediaPerformanceIndexRoute: typeof AuthenticatedOrgSlugMediaPerformanceIndexRoute
}

const AuthenticatedOrgSlugMediaPerformanceRouteChildren: AuthenticatedOrgSlugMediaPerformanceRouteChildren =
  {
    AuthenticatedOrgSlugMediaPerformanceSectionRoute:
      AuthenticatedOrgSlugMediaPerformanceSectionRoute,
    AuthenticatedOrgSlugMediaPerformanceIndexRoute:
      AuthenticatedOrgSlugMediaPerformanceIndexRoute,
  }

const AuthenticatedOrgSlugMediaPerformanceRouteWithChildren =
  AuthenticatedOrgSlugMediaPerformanceRoute._addFileChildren(
    AuthenticatedOrgSlugMediaPerformanceRouteChildren,
  )

interface AuthenticatedOrgSlugRouteChildren {
  AuthenticatedOrgSlugAuditRoute: typeof AuthenticatedOrgSlugAuditRouteWithChildren
  AuthenticatedOrgSlugMediaPerformanceRoute: typeof AuthenticatedOrgSlugMediaPerformanceRouteWithChildren
  AuthenticatedOrgSlugSettingsRoute: typeof AuthenticatedOrgSlugSettingsRoute
  AuthenticatedOrgSlugIndexRoute: typeof AuthenticatedOrgSlugIndexRoute
  AuthenticatedOrgSlugLaunchBudgetsRoute: typeof AuthenticatedOrgSlugLaunchBudgetsRoute
  AuthenticatedOrgSlugLaunchCreateRoute: typeof AuthenticatedOrgSlugLaunchCreateRoute
  AuthenticatedOrgSlugLaunchEditRoute: typeof AuthenticatedOrgSlugLaunchEditRoute
  AuthenticatedOrgSlugReviewDraftIdRoute: typeof AuthenticatedOrgSlugReviewDraftIdRoute
  AuthenticatedOrgSlugReviewIndexRoute: typeof AuthenticatedOrgSlugReviewIndexRoute
  AuthenticatedOrgSlugAuditNotesNoteIdRoute: typeof AuthenticatedOrgSlugAuditNotesNoteIdRoute
  AuthenticatedOrgSlugAuditReportsReportIdRoute: typeof AuthenticatedOrgSlugAuditReportsReportIdRoute
}

const AuthenticatedOrgSlugRouteChildren: AuthenticatedOrgSlugRouteChildren = {
  AuthenticatedOrgSlugAuditRoute: AuthenticatedOrgSlugAuditRouteWithChildren,
  AuthenticatedOrgSlugMediaPerformanceRoute:
    AuthenticatedOrgSlugMediaPerformanceRouteWithChildren,
  AuthenticatedOrgSlugSettingsRoute: AuthenticatedOrgSlugSettingsRoute,
  AuthenticatedOrgSlugIndexRoute: AuthenticatedOrgSlugIndexRoute,
  AuthenticatedOrgSlugLaunchBudgetsRoute:
    AuthenticatedOrgSlugLaunchBudgetsRoute,
  AuthenticatedOrgSlugLaunchCreateRoute: AuthenticatedOrgSlugLaunchCreateRoute,
  AuthenticatedOrgSlugLaunchEditRoute: AuthenticatedOrgSlugLaunchEditRoute,
  AuthenticatedOrgSlugReviewDraftIdRoute:
    AuthenticatedOrgSlugReviewDraftIdRoute,
  AuthenticatedOrgSlugReviewIndexRoute: AuthenticatedOrgSlugReviewIndexRoute,
  AuthenticatedOrgSlugAuditNotesNoteIdRoute:
    AuthenticatedOrgSlugAuditNotesNoteIdRoute,
  AuthenticatedOrgSlugAuditReportsReportIdRoute:
    AuthenticatedOrgSlugAuditReportsReportIdRoute,
}

const AuthenticatedOrgSlugRouteWithChildren =
  AuthenticatedOrgSlugRoute._addFileChildren(AuthenticatedOrgSlugRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedOrgSlugRoute: typeof AuthenticatedOrgSlugRouteWithChildren
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedOrgSlugRoute: AuthenticatedOrgSlugRouteWithChildren,
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PersonvernRoute: PersonvernRoute,
  PrivacyRoute: PrivacyRoute,
  OauthConsentRoute: OauthConsentRoute,
  ReviewDraftIdRoute: ReviewDraftIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
